// extracted by mini-css-extract-plugin
module.exports = {"icon":"AddGoalWidgetCard_icon_N3fWj","label":"AddGoalWidgetCard_label_dKNgs","card":"AddGoalWidgetCard_card_3VgfK","content-center":"AddGoalWidgetCard_content-center_2Tj_i"};